<div class="review-request-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">Review Request</h2>
    <button mat-icon-button aria-label="Close" (click)="cancel()" [disabled]="isSubmitting">
      <span class="svg-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M18.2197 4.71967L4.71967 18.2197C4.57902 18.3603 4.5 18.5511 4.5 18.75C4.5 18.9489 4.57902 19.1397 4.71967 19.2803C4.86032 19.421 5.05109 19.5 5.25 19.5C5.44891 19.5 5.63968 19.421 5.78033 19.2803L19.2803 5.78033C19.421 5.63968 19.5 5.44891 19.5 5.25C19.5 5.05109 19.421 4.86032 19.2803 4.71967C19.1397 4.57902 18.9489 4.5 18.75 4.5C18.5511 4.5 18.3603 4.57902 18.2197 4.71967Z"
            fill="#04304B" />
            <path
              d="M5.78033 4.71967C5.63968 4.57902 5.44891 4.5 5.25 4.5C5.05109 4.5 4.86032 4.57902 4.71967 4.71967C4.57902 4.86032 4.5 5.05109 4.5 5.25C4.5 5.44891 4.57902 5.63968 4.71967 5.78033L18.2197 19.2803C18.3603 19.421 18.5511 19.5 18.75 19.5C18.9489 19.5 19.1397 19.421 19.2803 19.2803C19.421 19.1397 19.5 18.9489 19.5 18.75C19.5 18.5511 19.421 18.3603 19.2803 18.2197L5.78033 4.71967Z"
              fill="#04304B" />
            </svg>
          </span>
        </button>
      </div>

      <!-- Dialog Content -->
      <div class="dialog-body">
        <div class="dialog-content">
          <!-- Customer Information Section -->
          <div class="customer-info">
            <h3 class="section-title">Details</h3>
            <div class="info-row">
              <span class="label">Request ID</span>
              <span class="value">{{ data.transactionRequest.tx_request_id }}</span>
            </div>
            <div class="info-row">
              <span class="label">Supplier</span> <!-- @product defined label -->
              <span class="value">{{ data.transactionRequest.supplier_company }}</span>
            </div>
            <div class="info-row">
              <span class="label">Amount Due</span>
              <span class="value">{{ data.transactionRequest.amount | currency }}</span>
            </div>
            <div class="info-row">
              <span class="label">Status</span>
              <span class="value">{{ data.transactionRequest.statusProductFormat }}</span> <!-- @product defined value -->
            </div>
            <div class="info-row">
              <span class="label">Request Date</span> <!-- @product defined label -->
              <span class="value">{{ data.transactionRequest.created_at | date }}</span>
            </div>
            <div class="info-row">
              <span class="label">Expires At</span>
              <span class="value">{{ data.transactionRequest.expires_at | date }}</span>
            </div>
            <div class="memo-row">
              <span class="label">Memo</span>
              <textarea class="value" readonly>{{ data.transactionRequest.memo }}</textarea>
            </div>
            @if (files.length > 0 && !loadingInvoices) {
              <div class="invoice-row">
                <span class="label">Invoice</span>
                @for (file of files; track file; let index = $index) {
                  <a (click)="onOpenFile(index)" target="_blank">{{ file.name }}</a>
                }
              </div>
            } @else {
              <!-- No invoice files available and done loading -->
              @if (!loadingInvoices) {
                <div class="invoice-row">
                  <span>No invoice files available</span>
                </div>
              }
              <!-- Loading spinner while invoices are being fetched -->
              @if (loadingInvoices) {
                <div class="invoice-row">
                  <mat-spinner [diameter]="20" color="accent"></mat-spinner>
                </div>
              }
            }
            <div class="href-links">
              <a (click)="onTermsClick()">
                Offer Summary & Terms
              </a>
            </div>
          </div>
        </div>

        <!-- Dialog Footer with Approve and Deny Buttons -->
        <div class="dialog-footer">
          @if (error) {
            <div class="error-message">
              <span class="error-text">{{ error }}</span>
            </div>
          }

          <div class="action-buttons">
            <!-- Render single dummy button if submitting -->
            @if (isSubmitting || loadingCreditCheck) {
              <button mat-flat-color color="accent" disabled="true">
                <mat-spinner [diameter]="20" color="accent"></mat-spinner>
              </button>
            }

            <!-- Render actual action buttons if not submitting -->
            @if (!isSubmitting && !loadingCreditCheck) {
              <button mat-raised-button color="primary" class="approve-btn"
                (click)="onAcceptClick()" [disabled]="isSubmitting || error">
                Accept Request
              </button>
            }
            @if (!isSubmitting && !loadingCreditCheck) {
              <button mat-stroked-button color="accent" class="deny-btn" (click)="onDeclineClick()">
                Decline Request
              </button>
            }
          </div>
        </div>
      </div>
    </div>
